import RequestUtils from "utils/RequestUtils";

export default class LineApi {
  private constructor() {}

  public static async getStatus(driverId: number) {
    return await RequestUtils.getVoid(`/line/status/${driverId}`);
  }

  public static async link(driverId: number, lineUserId: string) {
    return await RequestUtils.postVoid(`/line/link/${driverId}`, { lineUserId });
  }

  public static async unlink(driverId: number) {
    return await RequestUtils.postVoid(`/line/unlink/${driverId}`, {});
  }

  public static async updateNotifyMethod(
    driverId: number,
    notifyMethod: string
  ) {
    return await RequestUtils.postVoid(`/line/notifyMethod/${driverId}`, {
      notifyMethod,
    });
  }
}
